import {
  Component,
  ViewEncapsulation,
  OnInit,
} from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1205Model } from './kymw1205.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';

/**
 * 移動先に指定するPコードを管理するクラス
 *
 * @export KYMW1205Component
 * @class KYMW1205Component
 */
@Component({
  selector: 'app-kymw1205',
  templateUrl: 'kymw1205.component.html',
  styleUrls: ['kymw1205.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW1205Component
  extends PlessViewHelperSub
  implements OnInit
{
  public model: KYMW1205Model = new KYMW1205Model();

  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW1205Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1205';

  }

  /**
   * ボタン押下 確定
   *
   * @memberof KYMW1205Component
   */
  public eventConfirm_CLICKHandler() {
    this.model.output = {
      pCode: this.model.pCode,
    };
    this.closeFunction(this.model.output);
  }
}
